// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YeYu","questions":"styles_questions__3kIX2","footer":"styles_footer__2Iu_w"};